import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#008080', 
    },
    secondary: {
      main: '#004d40', 
    },
  },
  typography: {
    fontFamily: 'Arial, sans-serif', 
  },
});

export default theme;
